<template>
  <a-row :gutter="8" class="j-select-biz-component-box" type="flex">
    <a-col :class="{'full': !buttons}" class="left">
      <slot name="left">
        <a-select
          :disabled="disabled"
          :open="selectOpen"
          :options="selectOptions"
          :placeholder="placeholder"
          @click.native="visible=(buttons || disabled ?visible:true)"
          @dropdownVisibleChange="handleDropdownVisibleChange"
          allowClear
          mode="multiple"
          style="width: 100%;"
          v-model="selectValue"
        />
      </slot>
    </a-col>

    <a-col class="right" v-if="buttons">
      <a-button :disabled="disabled" @click="visible=true" icon="search" type="primary">{{ selectButtonText }}</a-button>
    </a-col>

    <j-select-biz-component-modal
      :visible.sync="visible"
      @options="handleOptions"
      v-bind="modalProps"
      v-model="selectValue"
    >
      <slot name="action" slot="buttons"></slot>
    </j-select-biz-component-modal>
  </a-row>
</template>

<script>
  import JSelectBizComponentModal from './JSelectBizComponentModal'

  export default {
    name: 'JSelectBizComponent',
    components: { JSelectBizComponentModal },
    props: {
      value: {
        type: String,
        default: ''
      },
      /** 是否返回 id，默认 false，返回 code */
      returnId: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // 是否支持多选，默认 true
      multiple: {
        type: Boolean,
        default: true
      },
      // 是否显示按钮，默认 true
      buttons: {
        type: Boolean,
        default: true
      },
      // 显示的 Key
      displayKey: {
        type: String,
        default: null
      },
      // 返回的 key
      returnKeys: {
        type: Array,
        default: () => ['id', 'id']
      },
      // 选择按钮文字
      selectButtonText: {
        type: String,
        default: '选择'
      }

    },
    data () {
      return {
        selectValue: [],
        selectOptions: [],
        dataSourceMap: {},
        visible: false,
        selectOpen: false
      }
    },
    computed: {
      valueKey () {
        return this.returnId ? this.returnKeys[0] : this.returnKeys[1]
      },
      modalProps () {
        const props = {
          valueKey: this.valueKey,
          multiple: this.multiple,
          returnKeys: this.returnKeys,
          displayKey: this.displayKey || this.valueKey,
          ...this.$attrs
        }
        return props
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (val) {
          if (val) {
            this.selectValue = val.split(',')
          } else {
            this.selectValue = []
          }
        }
      },
      selectValue: {
        deep: true,
        handler (val) {

          let rows = val.map(key => this.dataSourceMap[key])
          let data = val.join(',')
          if (data !== this.value) {
            this.$emit('select', rows)
            this.$emit('input', data)
            this.$emit('change', data)
          }
        }
      }
    },
    methods: {

      handleOptions (options, dataSourceMap) {
        this.selectOptions = options
        this.dataSourceMap = dataSourceMap
      },
      handleDropdownVisibleChange () {
        // 解决antdv自己的bug —— open 设置为 false 了，点击后还是添加了 open 样式，导致点击事件失效
        this.selectOpen = true
        this.$nextTick(() => {
          this.selectOpen = false
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .j-select-biz-component-box {
    @width: 82px;

    .left {
      width: calc(100% - @width - 8px);
    }

    .right {
      width: @width;
    }

    .full {
      width: 100%;
    }

    /deep/ .ant-select-search__field {
      display: none !important;
    }
  }
</style>
